import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchQueryDropdownComponent } from './search-query-dropdown/search-query-dropdown.component';
import { SearchDateDropdownComponent } from './search-date-dropdown/search-date-dropdown.component';
import {
  NgbDropdownModule,
  NgbNav,
  NgbNavItem,
  NgbNavLink,
} from '@ng-bootstrap/ng-bootstrap';
import { InputModule } from '../../components/inputs/input/input.module';
import { SearchComponent } from './search.component';
import { LetModule, PushModule } from '@ngrx/component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatepickerComponent } from '../../components/inputs/datepicker/datepicker.component';
import { ButtonComponent } from '../../components/button/button.component';
import { BadgeModule } from '../../components/badge/badge.module';
import { SearchLocationDropdownComponent } from './search-location-dropdown/search-location-dropdown.component';
import { EntityLogoComponent } from '../../components/entity-logo/entity-logo.component';
import { ResizeDirective } from '../../directives/resize.directive';
import { SearchMobileComponent } from './search-mobile/search-mobile.component';
import { LocationComponent } from '../../components/location/location.component';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';
import { PipeModule } from '../shared/pipes/pipe.module';

const declarations = [
  SearchComponent,
  SearchDateDropdownComponent,
  SearchLocationDropdownComponent,
  SearchLocationDropdownComponent,
  SearchQueryDropdownComponent,
  SearchMobileComponent,
];

@NgModule({
  declarations,
  imports: [
    BadgeModule,
    ButtonComponent,
    CommonModule,
    DatepickerComponent,
    FormsModule,
    InputModule,
    LetModule,
    NgbDropdownModule,
    NgbNav,
    NgbNavItem,
    NgbNavLink,
    PushModule,
    ReactiveFormsModule,
    EntityLogoComponent,
    ResizeDirective,
    LocationComponent,
    ClickOutsideDirective,
    PipeModule,
  ],
  exports: [...declarations],
})
export class SearchModule {}
